exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.settings[data-v-30c568a4] {\n  max-width: 100%;\n}\n@media (min-width: 800px) {\n.settings[data-v-30c568a4] {\n    max-width: 800px;\n    margin: 0 auto;\n}\n}\n", ""]);

// exports
